import * as angular from 'angular';
import { ManageUsersFiltersComponent } from './manage-users-filters.component';

export const ManageUsersFiltersModule = angular
  .module('manageUsersFilters', [])
  .component('manageUsersFilters', ManageUsersFiltersComponent).name;
